import { defineStore } from "pinia";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    lastNotification: null,
  }),

  actions: {
    showSuccessNotification(message) {
      this.setLastNotification({
        timeout: 3000,
        position: "center",
        color: "success",
        text: message,
      });
    },

    showErrorNotification(message) {
      this.setLastNotification({
        timeout: 3000,
        position: "center",
        color: "error",
        text: message,
      });
    },
    showWarningNotification(message) {
      this.setLastNotification({
        timeout: 3000,
        position: "center",
        color: "warning",
        text: message,
      });
    },

    setLastNotification(notification) {
      this.lastNotification = notification;
    },
  },

  getters: {
    getLastNotification: (state) => state.lastNotification,
  },
});
